import React, { FC, useRef } from 'react';
import styled from 'styled-components';
import { useRouter } from 'next/router';
import { useLocalizedRoutes } from '@homeproved/pro/feature-localized-routes';
import { useDisclosure } from 'react-use-disclosure';
import { LogoPro, OffCanvasToggle } from '@homeproved/shared/ui';
import { OffCanvasMenu } from './OffCanvasMenu';
import { useClickOutside } from '@homeproved/shared/util';

type MobileHeaderProps = {
  transparent: boolean;
};

const Wrapper = styled(({ transparent, ...restProps }) => <div {...restProps} />)`
  @media only screen and (min-width: ${({ theme }) => theme.breakpoints.values.xs}px) {
    display: none;
  }
  display: flex;
  height: 8rem;
  padding: 0 2rem;
  justify-content: space-between;
  align-items: center;
  background: ${({ transparent, theme }) =>
    transparent ? 'transparent' : theme.config.gradients.default};
`;

export const MobileHeader: FC<MobileHeaderProps> = ({ transparent }) => {
  const router = useRouter();
  const { getPath } = useLocalizedRoutes();
  const {
    isOpen: offCanvasOpen,
    toggle: onToggleOffCanvas,
    close: onCloseOffCanvas,
  } = useDisclosure(false);
  const toggleBtnRef: React.RefObject<HTMLDivElement> = React.useRef();
  const menuRef: React.RefObject<HTMLDivElement> = useRef();
  useClickOutside(menuRef, onCloseOffCanvas, [toggleBtnRef]);
  return (
    <>
      <Wrapper transparent={transparent}>
        <LogoPro width="23rem" onClick={() => router.push(getPath('/')).then()} />
        <OffCanvasToggle
          innerRef={toggleBtnRef}
          offCanvasOpen={offCanvasOpen}
          onToggleOffCanvas={onToggleOffCanvas}
        />
      </Wrapper>
      <OffCanvasMenu open={offCanvasOpen} toggleOffCanvas={onToggleOffCanvas} innerRef={menuRef} />
    </>
  );
};
